import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import Zone from '@wix/da-gruser-shared/pkg/components/Zone';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import GruserContext from '@wix/da-gruser-shared/pkg/context/GruserContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { getExhibitionistWidgetConfig } from '../../../widgets/Exhibitionist/widgetConfig';
import SubmissionDetails from '../../../SubmissionDetails';
import { getGruserForDeviation, isExtendedDeviationFullyLoaded } from '../../../DeviationPage/redux/helpers';
import ExtendedDetails from './ExtendedDetails';
import s from './Default.scss';
export const DefaultDetails = ({ deviation, className, contentClassName })=>{
    var _deviation_author;
    const dispatch = useDispatch();
    const isMobile = useContext(MobileContext);
    const { t } = useTranslation();
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviation_gruser_flag = useFlag('deviation_gruser');
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className, contentClassName)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['title-block'],
        "data-hook": BiDataHook.DEVIATION_META
    }, /*#__PURE__*/ React.createElement(SubmissionDetails, {
        deviation: deviation,
        showTitle: true
    })), isExtendedLoaded && /*#__PURE__*/ React.createElement(ExtendedDetails, {
        deviation: deviation
    }), deviation_gruser_flag && !isMobile && /*#__PURE__*/ React.createElement(BiLoggerContextProvider, {
        value: {
            creatorid: (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid
        }
    }, /*#__PURE__*/ React.createElement(GruserContext.Provider, {
        value: getGruserForDeviation(deviation)
    }, /*#__PURE__*/ React.createElement(Zone, {
        name: "local",
        withStaticAddWidget: true,
        mapModuleTypeToWidgetConfig: {
            exhibitionist: getExhibitionistWidgetConfig({
                t,
                dispatch
            })
        }
    }))));
};
DefaultDetails.displayName = 'DefaultDetails';
export default DefaultDetails;
